import { Card, CardContent, Stat, StatGroup } from '@shared/components';
import type { InvoicingMode } from '../types/security-admin.types';
import { invoicingModeLabel } from '../utils/invoicingMode';

interface SecurityGroupSummaryProps {
  dealersCount: number;
  productsCount: number;
  usersCount: number;
  invoicingMode: InvoicingMode;
}

export function SecurityGroupSummary({
  dealersCount,
  productsCount,
  usersCount,
  invoicingMode,
}: SecurityGroupSummaryProps) {
  const stats: { label: string; value: number | string }[] = [
    { label: 'Dealers', value: dealersCount },
    { label: 'Products', value: productsCount },
    { label: 'Users', value: usersCount },
    { label: 'Invoicing mode', value: invoicingModeLabel(invoicingMode) },
  ];

  return (
    <Card>
      <CardContent>
        <h3 className="font-semibold mb-3">Summary</h3>
        <StatGroup>
          {stats.map((s) => (
            <Stat key={s.label} label={s.label} value={s.value} />
          ))}
        </StatGroup>
      </CardContent>
    </Card>
  );
}
